import { Types } from "../actionTypes";
import { combineReducers, createSelector } from "@reduxjs/toolkit";

export const initialState = {
  geoLocationSuggestions: [],
  isSearchingGeoLocations: false,
  isSearchingGeoLocationDetails: false,
  isSearchingCurrentLocation: false,
  usersLocation: null,
  recentLocations: [],
  geoError: null,
};

const geoSearchResults = (state = initialState, action) => {
  switch (action.type) {
    /** Current location search */
    case Types.FETCHING_CURRENT_LOCATION: {
      return {
        ...state,
        isSearchingCurrentLocation: true,
        geoError: null,
      };
    }
    case Types.FETCHING_CURRENT_LOCATION_SUCCESS: {
      return {
        ...state,
        isSearchingCurrentLocation: false,
        usersLocation: action.payload,
      };
    }
    case Types.FETCHING_CURRENT_LOCATION_FAILURE: {
      return {
        ...state,
        isSearchingCurrentLocation: false,
        geoError: action.payload,
      };
    }
    case Types.RESET_GEO_ERROR: {
      return {
        ...state,
        geoError: null,
      };
    }
    /** location search */
    case Types.FETCH_GEO_LOCATION_RESULTS: {
      return {
        ...state,
        isSearchingGeoLocations: true,
      };
    }
    case Types.FETCH_GEO_LOCATION_RESULTS_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        geoLocationSuggestions: response,
        isSearchingGeoLocations: false,
      };
    }
    case Types.FETCH_GEO_LOCATION_RESULTS_FAILURE: {
      return {
        ...state,
        isSearchingGeoLocations: false,
      };
    }
    case Types.RESET_GEO_LOCATION_RESULTS:
    case Types.SET_CURRENT_LOCATION:
    case Types.SELECT_LOCATION: {
      return {
        ...state,
        geoLocationSuggestions: [],
      };
    }

    /** location details */
    case Types.FETCH_GEO_LOCATION_DETAILS: {
      return {
        ...state,
        isSearchingGeoLocationDetails: true,
      };
    }
    case Types.FETCH_GEO_LOCATION_DETAILS_SUCCESS:
    case Types.FETCH_GEO_LOCATION_DETAILS_FAILURE: {
      return {
        ...state,
        isSearchingGeoLocationDetails: false,
      };
    }

    /** recent location details */
    case Types.FETCH_RECENT_LOCATIONS_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        recentLocations: response,
      };
    }
    case Types.SIGN_OUT_SUCCESS:
      return {
        ...state,
        recentLocations: initialState.recentLocations,
      };
    default:
      return state;
  }
};

//selectors

export const searchingForGeoLocationResults = (state) =>
  state.geoSearchResults.isSearchingLocations;
export const getGeoLocationSuggestions = (state) => state.geoSearchResults.geoLocationSuggestions;

export const isSearchingGeoLocations = (state) => state.geoSearchResults.isSearchingGeoLocations;

export const getRecentLocations = createSelector(
  [(state) => state.geoSearchResults],
  (geoSearchResults) => {
    if (!geoSearchResults.recentLocations) {
      return [];
    }

    // Filter duplicates and current location
    const flags = new Set(geoSearchResults.recentLocations);
    const uniqueLocations = geoSearchResults.recentLocations.filter((location) => {
      if (flags.has(location.name) || location.name === "Current Location") {
        return false;
      }
      flags.add(location.name);
      return true;
    });
    return uniqueLocations;
  },
);

export const searchingForGeoLocationDetails = (state) =>
  state.geoSearchResults.isSearchingGeoLocationDetails;

export const getRecentLatLon = createSelector(
  [(state) => state.geoSearchResults],
  (geoSearchResults) => {
    if (geoSearchResults.recentLocations && geoSearchResults.recentLocations.length > 0) {
      return {
        lat: geoSearchResults.recentLocations[0].lat,
        long: geoSearchResults.recentLocations[0].lon,
      };
    }

    return {};
  },
);

export const isSearchingCurrentLocation = (state) =>
  state.geoSearchResults.isSearchingCurrentLocation;

export const getGeoError = (state) => state.geoSearchResults.geoError;

export default combineReducers({
  geoSearchResults,
});
